export default {
  default: 'Action effectuée avec succès',
  createEntity: 'Entité créée avec succès',
  editEntity: 'Entité éditée avec succès',
  pathCopied: 'Chemin copié dans le presse-papier',
  linkCopied: 'Lien copié dans le presse-papier',
  valueCopied: 'Valeur copiée dans le presse-papiers',
  authKeyCopied: 'Clé d\'authentification copiée dans le presse-papier',
  widgetIdCopied: 'Identifant du widget copié dans le presse-papier',
};
